// recon-period-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcd.areaStatus.notStarted': 'Not started',
  'rcd.areaStatus.inProgress': 'In progress',
  'rcd.areaStatus.waitingPeriodEnd': 'Waiting for period end',
  'rcd.areaStatus.deviation': 'Deviation',
  'rcd.areaStatus.approved': 'Approved',
  'rcd.areaStatus.notRelevant': 'Not relevant',
  'rcd.result.passed': 'Passed',
  'rcd.result.waiting': 'Waiting',
  'rcd.result.deviation': 'Deviation',
  'rcd.result.blocked': 'Blocked',
  'rcd.result.notAssessed': 'Not assessed',
  'rcd.type.auto': 'Automatic check',
  'rcd.type.professional': 'Professional judgement',
  'rcd.type.controller': 'Reviewer check',
  'rcd.area.noExternalBalance': 'No external balance to compare against',
  'rcd.area.noBalanceChecklist': 'No balance — the area is checkpoints',
  'rcd.area.unexplained': '{amount} unexplained',
  'rcd.area.matchesLedger': 'Agrees with the general ledger',
  'rcd.area.checkpoints': 'Checkpoints for the period',
  'rcd.area.accountOne': '{count} account',
  'rcd.area.accountMany': '{count} accounts',
  'rcd.area.noAccounts': 'No accounts',
  'rcd.area.docsMissing': '{count} missing',
  'rcd.area.docsComplete': 'Complete',
  'rcd.comp.inbox': 'Unposted documents in the inbox',
  'rcd.comp.received': 'Documents received but not posted',
  'rcd.comp.receivedNote': 'Included in the unposted documents above — not counted twice.',
  'rcd.comp.bankNoDoc': 'Bank transactions without a voucher',
  'rcd.comp.docNoBank': 'Vouchers without a linked payment',
  'rcd.comp.duplicates': 'Vouchers suspected of being duplicates',
  'rcd.comp.outsidePeriod': 'Postings dated outside the period',
  'rcd.comp.outsidePeriodNote': 'Plumme does not record a receipt date alongside the voucher date, so it cannot tell a correct late posting from a misdated one.',
  'rcd.comp.lateManual': 'Manual postings near period end',
  'rcd.comp.lateManualNote': 'Manual vouchers dated in the last {days} days of the period. A suggestion of what to look at — not a claim of error.',
  'rcd.comp.cutoff': 'Possible cut-off errors',
  'rcd.comp.cutoffNote': 'Requires a delivery or receipt date alongside the voucher date. Plumme does not have that trail yet.',
  'rcd.group.revenue': 'Revenue',
  'rcd.group.cogs': 'Cost of goods',
  'rcd.group.payroll': 'Payroll costs',
  'rcd.group.otherOpex': 'Other operating expenses',
  'rcd.basis.previousMonth': 'Previous month',
  'rcd.basis.lastYear': 'Same period last year',
  'rcd.basis.budget': 'Budget',
  'rcd.basis.forecast': 'Forecast',
  'rcd.priority.critical': 'Critical',
  'rcd.priority.high': 'High',
  'rcd.priority.normal': 'Normal',
  'rcd.taskStatus.open': 'Open',
  'rcd.taskStatus.waitingClient': 'Waiting for client',
  'rcd.taskStatus.needsReview': 'Needs review',
  'rcd.taskStatus.resolved': 'Resolved',
  'rcd.task.clientRequest': 'Client request',
  'rcd.task.docRequest': 'Request for documentation',
  'rcd.task.inbox': 'Inbox',
  'rcd.task.inboxRef': 'INBOX',
  'rcd.task.processInbox': 'Process {count} unposted documents',
  'rcd.reportStatus.notStarted': 'Not started',
  'rcd.reportStatus.dataIncomplete': 'Data basis incomplete',
  'rcd.reportStatus.readyToPrepare': 'Ready to prepare',
  'rcd.reportStatus.readyToSubmit': 'Ready to submit',
  'rcd.reportStatus.submitted': 'Submitted',
  'rcd.reportStatus.waitingPeriodEnd': 'Waiting for period end',
  'rcd.report.period': 'Period report for the client',
  'rcd.report.result': 'Income report',
  'rcd.report.balance': 'Balance sheet report',
  'rcd.report.ledger': 'General ledger',
  'rcd.report.aged': 'Aged customer and supplier list',
  'rcd.report.dataComplete': 'Complete',
  'rcd.report.dataIncomplete': 'Incomplete',
  'rcd.report.dueOwn': 'The firm\'s own period deadline',
  'rcd.report.dueNone': 'No period deadline is set on the period',
  'rcd.report.vat': 'VAT return',
  'rcd.report.vatTerm': 'Term {term} {year}',
  'rcd.report.dueVatModel': 'Calculated by the VAT term model',
  'rcd.report.aMelding': 'A-melding',
  'rcd.report.withholding': 'Withholding tax and employer contributions',
  'rcd.report.dueNotRegistered': 'Deadline not recorded in Plumme — followed up in the payroll area',
  'rcd.master.bank': 'All bank accounts are reconciled',
  'rcd.master.subledger': 'Customer and supplier subledgers are reconciled',
  'rcd.master.vat': 'VAT has been checked',
  'rcd.master.payroll': 'Payroll and public charges have been checked',
  'rcd.master.docs': 'Documentation is complete',
  'rcd.master.docsSource': '{area}: {count} account(s) without documentation',
  'rcd.master.docsAllOk': 'All accounts that require an external basis have documentation or a note',
  'rcd.master.docsText': 'Deviation – {count} documentation requirements missing',
  'rcd.master.reporting': 'The period is ready for reporting',
  'rcd.cross.unexplainedDiff': 'Unexplained difference',
  'rcd.cross.matches': 'Agrees',
  'rcd.cross.ledgerRule': 'The general ledger balances, with equal debit and credit totals.',
  'rcd.cross.srcLedger': 'General ledger',
  'rcd.cross.ledgerOff': 'Debit and credit don\'t add up',
  'rcd.cross.bankRule': 'Bank balances agree with the bank reconciliations.',
  'rcd.cross.srcBank': 'Bank, general ledger',
  'rcd.cross.subledgerRule': 'Customer and supplier subledgers agree with the general ledger.',
  'rcd.cross.srcSubledger': 'Accounts receivable, accounts payable, general ledger',
  'rcd.cross.vatRule': 'The VAT basis agrees with the relevant general ledger accounts.',
  'rcd.cross.srcVat': 'VAT reconciliation, general ledger',
  'rcd.cross.payrollRule': 'The payroll basis agrees with the payroll run and the general ledger.',
  'rcd.cross.srcPayroll': 'Payroll system, general ledger, A-melding',
  'rcd.cross.taxRule': 'Tax withholding and public charges agree with the payroll and charges basis.',
  'rcd.cross.srcTax': 'Payroll system, tax account',
  'rcd.cross.waitingPeriodEnd': 'Waiting for period end',
  'rcd.cross.signRule': 'Asset accounts with a negative balance have been examined.',
  'rcd.cross.srcTrialBalance': 'Trial balance',
  'rcd.cross.negativeAccounts': '{count} account(s) with a negative balance',
  'rcd.cross.noneFound': 'None found',
  'rcd.cross.unclearedRule': 'Temporary and unclear accounts have been reviewed.',
  'rcd.cross.srcOther': 'Other balance sheet',
  'rcd.cross.openItems': '{count} open items',
  'rcd.cross.noOpenItems': 'No open items',
  'rcd.cross.itemsRule': 'All material reconciliation items are handled or documented for follow-up.',
  'rcd.cross.srcAllAreas': 'All areas',
  'rcd.cross.itemsStillOpen': '{count} items still open',
  'rcd.cross.allItemsDone': 'All items are handled',
  'rcd.cross.itemsCount': '{count} items',
  'rcd.cross.changedRule': 'No approved reconciliation has been changed without a new check.',
  'rcd.cross.srcActivityLog': 'Activity log',
  'rcd.cross.changedAfterApproval': '{areas} changed after approval',
  'rcd.cross.areasCount': '{count} areas',
  'rcd.auto.noAccountsInArea': 'No accounts in the area',
  'rcd.auto.a1': 'All relevant reconciliation areas are identified.',
  'rcd.auto.a1Source': '{count} areas identified from the client setup',
  'rcd.auto.a2': 'All bank accounts are reconciled.',
  'rcd.auto.a3': 'Customer and supplier subledgers are reconciled.',
  'rcd.auto.a4': 'VAT is checked when relevant for the period.',
  'rcd.auto.a5': 'Payroll and public charges are checked when relevant.',
  'rcd.auto.a6': 'All material balance sheet areas are handled.',
  'rcd.auto.b2': 'Bank transactions without documentation have been followed up.',
  'rcd.auto.b2Source': '{count} bank transactions without a voucher',
  'rcd.auto.b2NoBank': 'No bank reconciliation in the period',
  'rcd.auto.c1': 'The result trend has been compared with a relevant basis of comparison.',
  'rcd.auto.c1Source': '{count} key figures compared with {basis}',
  'rcd.auto.c1NoLines': 'No income statement lines in the period',
  'rcd.auto.d1': 'The reporting basis builds on an unchanged reconciliation basis.',
  'rcd.auto.d1Unchanged': 'No approved reconciliation has been changed afterwards',
  'rcd.auto.d2': 'All reports and obligations for the period are identified.',
  'rcd.auto.d2Source': '{count} reports/obligations identified',
  'rcd.auto.d3': 'Reports and specifications have a complete data basis.',
  'rcd.auto.d3Source': '{count} reports have an incomplete data basis',
  'rcd.auto.d3AllComplete': 'All reports have a complete data basis',
  'rcd.auto.d5': 'The period is ready for review.',
  'rcd.auto.d5Blocked': 'Calculated — see the blockers in the conclusion',
  'rcd.auto.d5None': 'No blockers',
  'rcd.auto.d4': 'Analytical deviations are explained.',
  'rcd.auto.d4Source': '{count} analytical deviations without an explanation',
  'rcd.auto.d4AllExplained': 'All comparisons are explained or within expectations',
  'rcd.group.scope': 'A. Scope and reconciliations',
  'rcd.group.completeness': 'B. Completeness and accruals',
  'rcd.group.analytical': 'C. Analytical review',
  'rcd.group.reporting': 'D. Reporting',
  'rcd.group.professional': 'Professional assessments',
  'rcd.blocker.deviation': '{count} account(s) are marked as deviation',
  'rcd.blocker.missingDocs': '{count} account(s) lack documentation',
  'rcd.blocker.openItems': '{count} open reconciliation items',
  'rcd.blocker.waitingTermEnd': 'Waiting for period end — the term ended {date}',
  'rcd.blocker.basisMoved': 'The basis has moved since approval',
  'rcd.blocker.inboxGroup': 'Inbox',
  'rcd.blocker.inboxItems': '{count} documents have not been processed',
  'rcd.blocker.analyticalGroup': 'Analytical review',
  'rcd.blocker.explanationsMissing': '{count} explanations missing ({areas})',
  'rcd.blocker.periodGroup': 'The period',
  'rcd.blocker.periodNotEnded': 'The period has not ended yet',
});
